import { useEffect } from "react";
import { ProviderConfigsCard } from "./card";
import { ProviderConfigsNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { ProviderConfigsTable } from "./table";

export default function ProviderConfigs() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Configurations des fournisseurs");
  }, []);

  return (
    <Routes>
      <Route index element={<ProviderConfigsTable />} />
      <Route path="/new" element={<ProviderConfigsNew />} />
      <Route path=":id" element={<ProviderConfigsCard />} />
    </Routes>
  );
}
